import { callApi, ENDPOINTS } from 'utils/api/callApi'

interface IGetTenderTrackingInfoRequest {
  shipmentId: number
}

interface IGetTenderTrackingInfoResponse {
  shipperStatus: {
    acceptedToday: string
    acceptedPerCadence: string
  }
  acceptanceCriteria: string
  laneId: string
  shipperRateId: string
}

/**
 * Fetches tender tracking info for given shipment id
 */
const getTenderTrackingInfo = ({
  shipmentId,
}: IGetTenderTrackingInfoRequest): Promise<IGetTenderTrackingInfoResponse> =>
  callApi({
    endpoint: ENDPOINTS.shipments,
    group: `${shipmentId}/tender_tracking_info`,
  })

export default getTenderTrackingInfo
